import Vue from 'vue'
import Router from 'vue-router'

//官网
// import Index from '../components/web/Index'
import IndexV2 from '../components/web/IndexV2'
import Cooperate from '../components/web/Cooperation'
import Contact from '../components/web/Contact'
import AboutUs from "../components/web/AboutUs";
import Product from "../components/web/Product";
import JoinUs from "../components/web/JoinUs";
import Area from "../components/web/Area";
import Page from "../components/web/Page";
import Card from "../components/web/Card";

//官网后台
// import AdminIndex from '@/components/admin/Index'
const AdminIndex = () =>import( '@/components/admin/Index')
// import IndexLeft from '@/components/admin/IndexLeft'
const IndexLeft = () =>import( '@/components/admin/IndexLeft')
// import vMain from '@/components/admin/Main'
const vMain = () =>import( '@/components/admin/Main')
// import Login from '@/components/admin/Login'
const Login = () =>import( '@/components/admin/Login')
// import Logout from '@/components/admin/Logout'
const Logout = () =>import( '@/components/admin/Logout')
import managerRouter from "./managerRouter";
import adwebRouter from "./adwebRouter";
import productRouter from "./productRouter";
import formuiRouter from "./formuiRouter";
import cardRouter from "./cardRouter";




Vue.use(Router)

export default new Router({
    // redirect: "/index",
    routes: [
        {
            path: '/',
            redirect: "/index",
        },

        //官网
        {
            path: '/index',
            component: IndexV2,
            meta: { title: '首页' }
        },
        // {
        //     path: '/index',
        //     component: IndexV2,
        //     meta: { title: '首页' }
        // },
        {
            path: '/cooperate',
            component: Cooperate,
            meta: { title: '商务合作' }
        },
        {
            path: '/contact',
            component: Contact,
            meta: { title: '联系我们' }
        },
        {
            path: '/join',
            component: JoinUs,
            meta: { title: '加入我们' }
        },
        {
            path: '/card',
            component: Card,
            meta: { title: '名片' }
        },

        {
            path: '/area',
            component: Area,
            meta: { title: '关于我们' }
        },
        {
            path: '/about',
            component: AboutUs,
            meta: { title: '产品线' }
        },{
            path: '/product',
            component: Product,
            meta: { title: '产品线' }
        },
        {
            path: '/page',
            component: Page,
            meta: { title: '加载中' }
        },

        //官网后台
        {
            path: '/admin',
            component: AdminIndex,
            children: [

                {
                    path: '/admin',
                    name: 'indexmain',
                    components: {indexLeft: IndexLeft, indexRight: vMain}
                },
                {
                    path: '/admin/index',
                    name: 'index',
                    components: {indexLeft: IndexLeft, indexRight: vMain}
                },
                adwebRouter.adWebAdd,
                adwebRouter.adWebEdit,
                adwebRouter.adWebList,
            ].concat(cardRouter)
        },
        {
            path: '/admin/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/admin/logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/admin/managers',
            component: AdminIndex,
            children: managerRouter
        },
        {
            path: '/admin/product',
            component: AdminIndex,
            children: productRouter
        },
        {
            path: '/formui',
            component: AdminIndex,
            children: formuiRouter
        },



  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js